<!--  -->
<template>
    <div class="waitPay">
        <div class="header-top">
            <img src="@/assets/images/plate_icon1.png" alt="" />
            <span class="span">{{ $route.query.plateNum }}</span>
        </div>

        <div class="waitPay-content" v-if="list.length > 0">
            <div :name="item" v-for="(item, index) in list" :key="index">
                <div class="waitPay-content-item-wrap flex-column justify-around">
                    <div class="waitPay-content-item-header flex align-center justify-between">
                        <p class="waitPay-content-item-title">{{ item.parkName }}</p>
                        <p class="waitPay-content-item-title">{{ item.parkCode }}</p>
                    </div>
                    <div class="waitPay-content-item flex align-center">
                        <img class="waitPay-content-item1" src="@/assets/images/pay/parkingPay-long.png" alt="" />
                        <p class="waitPay-content-item-title">驶入时间</p>
                        <p class="waitPay-content-item-value">{{ item.inTime }}</p>
                    </div>
                    <div class="waitPay-content-item flex align-center">
                        <img class="waitPay-content-item1" src="@/assets/images/pay/parkingPay-long.png" alt="" />
                        <p class="waitPay-content-item-title">驶离时间</p>
                        <p class="waitPay-content-item-value">{{ item.outTime ? item.outTime : "停车中" }}</p>
                    </div>
                    <div class="waitPay-content-item flex align-center">
                        <img class="waitPay-content-item1" src="@/assets/images/pay/parking-time.png" alt="" />
                        <p class="waitPay-content-item-title">停车时长</p>
                        <p class="waitPay-content-item-value">{{ secondToMinute(item.parkSeconds) }}分钟</p>
                    </div>
                    <!-- <div class="waitPay-content-item flex align-center">
                        <img class="waitPay-content-item1" src="@/assets/images/pay/parkingPay-image.png" alt="" />
                        <p class="waitPay-content-item-title">驶入图片</p>
                        <p class="waitPay-content-item-value" style="color: #009af3" @click="previewImage(item)">查看图片</p>
                    </div>
                    <div class="waitPay-content-item flex align-center">
                        <img class="waitPay-content-item1" src="@/assets/images/pay/parkingPay-image.png" alt="" />
                        <p class="waitPay-content-item-title">驶出图片</p>
                        <p class="waitPay-content-item-value" style="color: #009af3" @click="previewImage(item)">查看图片</p>
                    </div> -->
                    <div class="fee">
                        <div class="inner-item">
                            <div>停车费用</div>
                            <div>￥{{ Number(item.consume).toFixed(2) }}</div>
                        </div>
                        <div class="inner-item">
                            <div>已支付</div>
                            <div>￥{{ Number(item.realPay).toFixed(2) }}</div>
                        </div>
                        <div class="inner-item">
                            <div>还需支付</div>
                            <div>￥{{ Number(item.needPay).toFixed(2) }}</div>
                        </div>

                    </div>

                    <div class="waitPay-item-money flex align-center justify-between">
                        <p class="waitPay-content-item-title">
                            需支付:<span class="waitPay-item-money-style">￥{{ Number(item.needPay).toFixed(2) }}</span>
                            ，可代付：<span class="waitPay-item-money-style">￥{{ Number(limitMoney).toFixed(2) }}</span>
                        </p>
                    </div>
                </div>
            </div>

        </div>
        <!-- 底部缴费按钮 -->
        <div v-if="list.length > 0" class="waitPay-confirm flex align-center">
            <div>
                <span>总计<span style="color: #009af3">{{ list.length}}</span>笔订单，合计代付</span>
                <span class="waitPay-confirm-money">￥{{ totalMoney }}</span>
            </div>
            <van-button class="waitPay-confirm-btn button" @click="payNow"> 一键代付</van-button>
        </div>
        <div class="waitPay-content no-data" v-if="list.length == 0 && nodata">
            <img src="@/assets/images/empty.png" alt="" />
            <div>费用已缴清</div>
        </div>

        <loading :show="payLoading" text="支付中..." />
    </div>
</template>

<script>
import { queryParkingRecordPaymentOnBehalf, commonInsideOrderSubmit } from '@/api/api'
import { secondToMinute, deleteTimePoint, throttleBytimestamp } from "@/libs/tools";
import Loading from '@/components/base/loading/loading.vue'
export default {
    name: 'paymentParkingRecords',
    components: {
        Loading
    },

    data() {
        return {
            list: [],
            nodata: false,
            payLoading: false,
            limitMoney: 0,
        };
    },

    computed: {
        totalMoney() {
            let totalMoney = 0
            this.list.forEach(item => {
                let money = item.needPay > this.limitMoney ? Number(this.limitMoney) : Number(item.needPay)
                totalMoney += money;
            })
            return Number(totalMoney).toFixed(2);
        }
    },

    mounted() {
        let { limitMoney, ...query } = this.$route.query
        this.limitMoney = limitMoney
        queryParkingRecordPaymentOnBehalf(query).then(res => {
            if (res.data.length > 0) {
                this.list = res.data;
            }
            else {
                this.nodata = true;
            }

        })
    },

    methods: {
        secondToMinute,
        payNow: throttleBytimestamp(function () {
            let requestBody = this.getRequestBody(this.list)
            this.payLoading = true
            commonInsideOrderSubmit(requestBody)
                .then((res) => {
                    if (res.code == 200) {
                        this.$toast('代付成功')
                        setTimeout(() => {
                            this.$router.go(-1)
                        }, 1000)

                    }
                })
                .finally(() => {
                    this.payLoading = false
                })
        }, 1000),
        getRequestBody(list) {
            let requestObj = {
                payChannel: 'paymentmerchantpay',
                business: "batchpay",
                parkType: 1,
                totalRealMoney: this.totalMoney,
                certId: list[0].plateNum,
                orderInfo: [],
                paymentCode: this.$route.query.code,
                type: this.$route.query.type
            }
            list.forEach(item => {
                let money = item.needPay > this.limitMoney ? Number(this.limitMoney) : Number(item.needPay)

                requestObj.orderInfo.push({
                    buyer: item.plateNum,
                    parkCode: item.parkCode,
                    plateNum: item.plateNum,
                    stallCode: item.stallCode,
                    arrearsType: item.status == 2 ? 1 : 2,
                    orderMoney: item.consume,
                    couponMoney: 0,
                    realMoney: money,
                    // couponDetailId: item.couponDetailId,
                    // couponRandomId: item.couponRandomId,
                    couponTicketMoney: 0,
                    couponRandomMoney: 0,
                    payForMoney: 0,
                    parkingRecordId: item.parkingRecordId,
                    goodSubject: `停车代付`,
                    goodDetail: `停车代付`,
                })
            })
            return requestObj
        }
    }
}

</script>
<style lang="less" scoped>
@import "~@/assets/style/color.less";

.wait-button {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 26px !important;
}

.button {
    color: #fff;
    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
}

.inner-item {
    margin-bottom: 10px;
    font-size: 26px;
    display: flex;
    justify-content: space-between;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #666;
}

.fee {
    background-color: #f2f6f5;
    border-radius: 10px;
    padding: 15px 15px;
}

.bold-title {
    font-weight: bold;
    margin-bottom: 20px;
}

.waitPay {
    height: 100vh;

    .waitPay-header {
        width: 750px;
        height: 90px;
        padding: 30px;
        position: fixed;
        top: 0;
        left: 0;
        background-color: #fff;
        z-index: 99;

        .waitPay-date {
            font-size: 28px;
            color: #666666;

            i {
                margin: 0 4px;
            }
        }
    }

    .waitPay-content {
        position: relative;
        padding: 0px 24px 0px 24px;
        height: calc(100vh - 124px - 100px);
        margin-top: -50px;
        overflow-y: scroll;
        border-radius: 16px;
        // border: 1px red solid;

        .waitPay-content-item-wrap {
            width: 702px;
            min-height: 520px;
            border-radius: 16px;
            background-color: #fff;
            padding: 0 30px 30px 30px;
            margin-bottom: 16px;

            .waitPay-content-item-header {
                width: 100%;
                height: 90px;
                font-size: 30px;
                border-bottom: 1px solid #dbdada;
                margin-bottom: 10px;
            }

            .waitPay-content-item {
                margin: 7px 0;

                .waitPay-content-item1 {
                    width: 24px;
                    height: 24px;
                }

                .waitPay-content-item-title {
                    margin-left: 17px;
                    vertical-align: top;
                }

                .waitPay-content-item-value {
                    margin-left: auto;
                    color: #666666;
                }
            }

            .waitPay-content-coupon {
                margin: 20px 0;
                width: 100%;

                .waitPay-content-img {
                    width: 28px;
                    height: 28px;
                    margin-right: 13px;
                }

                color: #666666;
                font-size: 28px;

                .waitPay-content-coupon-right {
                    margin-left: auto;
                    font-size: 28px;

                    img {
                        width: 12px;
                        height: 21px;
                        margin-left: 26px;
                    }
                }
            }

            .waitPay-item-money {
                // color: #009af3;
                border-top: 1px solid #dbdada;
                // text-align: right;
                // font-size: 50px;
                padding-top: 16px;
            }

            .waitPay-item-money-style {
                font-size: 50px;
                color: #009af3;
            }
        }
    }

    .waitPay-confirm {
        width: 750px;
        height: 124px;
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #fff;
        justify-content: space-between;
        // justify-content: flex-end;
        padding: 24px;

        .waitPay-confirm-money {
            margin: 0 18px;
            color: @main-color;
            font-size: 50px;
        }
    }
}

.waitPay-confirm-btn {
    width: 200px;
    height: 72px;
    color: #fff;
    font-size: 30px;
    border-radius: 16px;
}

.info-button {
    height: 64px;
    width: 200px;
    font-size: 30px;
    color: #009af3;
    border: 1px #00c6ea solid;
}

.no-coupon {
    margin-left: auto;
    color: #fff;
    font-size: 24px;
    border-radius: 40px;
    background-color: #ff0000;
    padding: 0 10px;
}

.header-top {
    position: relative;
    color: #ffffff;
    height: 150px;
    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
    border-radius: 0px 0px 100px 100px;
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 35px;

    img {
        height: 32px;
        width: 40px;
        margin-right: 20px;
        margin-top: -50px;
    }

    .span {
        margin-top: -50px;
    }

    .van-icon {
        margin-top: -25px;
        margin-left: 5px;
    }
}

.no-data {
    background-color: #fff;
    height: calc(100vh - 100px) !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 32px;

    img {
        margin-top: -400px;
        width: 300px;
        height: 230px;
    }
}

.to-login {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 100px;
    border-radius: 10px;
    margin-top: 20px;
    font-size: 24px;
    color: #009af3;
    background-color: #e3f5ff;
}
</style>
